<button type="button" (click)="add()" class="{{classCustom}}">
      <i class="fa-solid fa-cart-shopping"></i>
      <span>Comprar</span> 
</button>   
<loader classCustom="absolute" [hidden]="!loader"></loader>  
  